<template>
  <!-- eslint-disable max-len -->
  <div class="cf-progress-ring">
    <svg
      ref="svg"
      :viewBox="`0 0 ${ canvasSizeX } ${ canvasSizeY}`"
      overflow="visible"
    >
      <circle
        class="cf-progress-ring__circle-bottom"
        :r="graphRadius"
        :cx="canvasSizeX / 2"
        :cy="canvasSizeY / 2"
        :stroke-width="strokeWidth"
      />

      <circle
        ref="circle"
        class="cf-progress-ring__circle-top"
        :r="graphRadius"
        :cx="(canvasSizeX / 2) * -1"
        :cy="canvasSizeY / 2"
        :stroke-width="strokeWidth"
        transform="rotate(-90)"
      />
    </svg>

    <div class="cf-progress-ring__content">
      <span class="cf-icon icon--smedium far fa-gift" />
    </div>
  </div>
</template>

<script>
  import numberDisplay from '@/helpers/number-display';

  export default {
    name: 'CfProgressRing',

    props: {
      progress: {
        type: Number,
        default: 0
      },

      steps: {
        type: Number,
        default: 100
      }
    },

    data() {
      return {
        canvasSizeX: 100,
        canvasSizeY: 100,
        checkpointIconSize: 14,
        checkpointRadius: 12,
        graphRadius: 46,
        strokeWidth: 8
      };
    },

    computed: {
    },

    watch: {
      progress: 'renderProgress',
      steps: 'renderProgress'
    },

    mounted() {
      this.renderProgress();
    },

    methods: {
      numberDisplay,

      renderProgress() {
        const { circle } = this.$refs;

        if (!circle) return;

        const radius = this.graphRadius;
        const circumference = radius * 2 * Math.PI;
        const { steps } = this;
        const progress = Math.min(steps, this.progress);

        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        circle.style.strokeDashoffset = circumference;

        setTimeout(() => {
          if (!this.$el || !this.$refs.circle) return;

          // NOTE: This slight delay allows the CSS transistion animation to kick in properly
          this.$el.classList.add('cf-progress-ring--animate');

          let offset;

          if (progress === 0) {
            offset = circumference;
          }
          else if (progress === steps) {
            offset = 0;
          }
          else {
            offset = circumference - ((progress / steps) * circumference);
          }

          circle.style.strokeDashoffset = offset;
        }, 25);
      }
    }
  };
</script>
